module.exports = __webpack_public_path__ + "img/icon_timer.02f467db.svg";